module.exports = __webpack_public_path__ + "assets/icons/table-sorted-asc.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/svg/table-sorted-asc.svg
// module id = 0PIR
// module chunks = 1